import React, { useState } from "react";
import SkeletonLoader from "./skeletonLoader";

const DynamicTab = ({
  sections = [],
  sx = {},
  skeletonLoader = {},
  actionableContent,
  activeContent,
  onContentSelect,
}) => {
  const [tabValue, setTabValue] = useState("1");
  const [loaderOpen, setLoaderOpen] = useState(false);

  const handleTabChange = (id) => {
    setTabValue(id);
    setLoaderOpen(true);
    setTimeout(() => {
      setLoaderOpen(false);
    }, 2000);
  };

  return (
    <div style={{ width: "100%" }}>
      {/* Tab Header */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid var(--primary-border-bottom-color)",
          ...(sx.tabList || {}),
        }}
      >
        {sections.map((item) => {
          const isActive = tabValue === item.id;
          const isDisabled = item.disabled;

          return (
            <button
              key={item.key}
              onClick={() => !isDisabled && handleTabChange(item.id)}
              disabled={isDisabled}
              style={{
                padding: "8px 16px",
                border: "none",
                background: "none",
                cursor: isDisabled ? "not-allowed" : "pointer",
                borderBottom: isActive
                  ? "3px solid var(--active-option-color)"
                  : "3px solid transparent",
                color: isDisabled
                  ? "var(--card-tertiary-color)"
                  : isActive
                  ? "var(--active-option-color)"
                  : "var(--card-secondary-color)",
                fontWeight: isActive ? "600" : "500",
                fontSize: "14px",
                textTransform: "inherit",
                ...(sx.tabHeaderSize || {}),
              }}
            >
              {item.display_name}
            </button>
          );
        })}
      </div>

      {/* Tab Panels */}
      <div style={{ ...(sx.tabContent || {}), paddingTop: "15px" }}>
        {sections.map((item) =>
          tabValue === item.id ? (
            <div key={item.key}>
              {loaderOpen ? (
                <SkeletonLoader
                  style={skeletonLoader.sx}
                  rowCount={skeletonLoader.rowCount}
                  rowHeight={skeletonLoader.rowHeight}
                />
              ) : actionableContent ? (
                item.tab_content(activeContent, onContentSelect)
              ) : (
                item.tab_content
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default DynamicTab;
